import { useEffect, useState } from 'react';
import { useWindowSize } from 'usehooks-ts';
const MOBILE_BREAKPOINT = 1024;
export function useIsMobile() {
  const [isMobile, setIsMobile] = useState(global?.userAgent?.isMobile);
  const clientIsMobile = useWindowSize()?.width < MOBILE_BREAKPOINT;
  useEffect(() => {
    setIsMobile(clientIsMobile);
    global.isMobile = clientIsMobile;
  });
  return isMobile;
}
export function useTouchHandlerName() {
  const handlerName = global?.userAgent?.isMobile ? 'onTouchStart' : 'onClick';
  return handlerName;
}